import React from "react";
import { Row, Col } from "react-bootstrap";
import { COLOR_POSITIVE } from "../../../GlobalColors";

export default function AggregateCounts({
  total,
  min_age,
  max_age,
  mean_age,
  female_percent,
  male_percent,
}: Data.MiscMetrics) {
  return (
    <Row className="d-flex flex-column my-auto mx-auto">
      <Col className="text-center mb-3">
        <p className="h5">Total Confirmed Cases</p>
        <h2 className="font-weight-bold" style={{ color: COLOR_POSITIVE }}>
          {total}
        </h2>
      </Col>
      <Col className="text-center mb-3">
        <p className="h5">Age Range</p>
        <h2 className="font-weight-bold" style={{ color: COLOR_POSITIVE }}>
          {min_age}-{max_age} (Mean {mean_age})
        </h2>
      </Col>
      <Col className="text-center">
        <p className="h5">Gender Distribution</p>
        <h2 className="font-weight-bold" style={{ color: COLOR_POSITIVE }}>
          {female_percent}% Female / {male_percent}% Male
        </h2>
      </Col>
    </Row>
  );
}
